import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useFormContext } from 'react-hook-form';
import { TextField } from 'seagull';
import { positiveQuantityInputProps } from '~/constants';
import { connectControllerToTextField } from '~/utils/react-hook-form.utils';
export default function PriceTextField(param) {
    let { onChange = ()=>{}, testId, disabled } = param;
    const { control, watch } = useFormContext();
    const [pricing, unitName] = watch([
        'pricing',
        'unitName'
    ]);
    const getLabel = ()=>{
        if (pricing === 'fixed') {
            return 'Price';
        }
        if (pricing === 'range') {
            return 'Max price';
        }
        return "Price per ".concat(pricing === 'hour' ? 'hour' : 'unit');
    };
    const getSuffix = ()=>{
        if (pricing === 'unit') {
            if (!unitName) return undefined;
            const shouldEllipsize = unitName.length > 20;
            return /*#__PURE__*/ _jsx("span", {
                style: shouldEllipsize ? {
                    whiteSpace: 'nowrap',
                    maxWidth: '20ch',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                } : {
                    whiteSpace: 'nowrap'
                },
                children: "/".concat(unitName)
            });
        }
        if (pricing === 'hour') return '/hr';
        return undefined;
    };
    return /*#__PURE__*/ _jsx(Controller, {
        control: control,
        name: "price",
        rules: {
            validate: (val)=>val && +val >= 0 || 'Insert a non-negative price'
        },
        render: (renderProps)=>{
            const connectedProps = connectControllerToTextField(renderProps);
            return /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({
                disabled: disabled,
                isMoney: true,
                alwaysShrinkLabel: true,
                inputProps: positiveQuantityInputProps,
                label: getLabel(),
                prefix: "$",
                suffix: getSuffix(),
                testId: testId
            }, connectedProps), {
                onChange: (e)=>{
                    connectedProps.onChange(e);
                    onChange(e.target.value);
                }
            }));
        }
    });
}
